<template>
    <div>
        <div class="columns is- mt-2 ">
            <div  v-for="order in orders" :key="order._id" class="column  is-half-tablet is-half-desktop is-one-third-widescreen is-one-quarter-fullhd">
                <div class=" p-3">
                    <div @click="viewDetails(order)" class="mb-3">
                        <div class="columns is-mobile">
                            <div class="column is-two-thirds">
                                <h4 class="title is-5 mb-3"> {{ order.userName }} </h4>
                                <h6 class="is-5 mb-2 has-text-weight-medium">GH₵{{ formatPrice(order.totalPrice) }}</h6>
                                <p class="subtitle is-6 "> {{ formatAMPM( new Date(order.createdAt)) }}</p>
                                <b-tag v-if="order.scheduled" rounded class="mt-" type="is-primary"> Scheduled</b-tag>
                                <span v-if="order.scheduled" class="mt-2 small has-text-dark has-text-weight-medium is-flex is-align-items-center ml-0">  <feather size="16" class="has-text-primary mr-1" type="clock"></feather> {{ formatAMPM(order.scheduled) }} </span>
                            </div>
                            <div class="column ">
                                <b-tag rounded :type=" (order.orderDelivered !== null ? 'is-success' : order.cancelled ? 'is-danger' : order.confirmed == null ? 'is-warning' : ( order.courierAssigned || order.courierDelivering ? 'is-info' : 'is-light'))" class="my-2">{{ order.status }}</b-tag>
                            </div>
                        </div>
                    </div>
                    <div v-if="order.confirmed == null && order.cancelled == null" class="columns is-mobile">
                        <div class="column is-half p-1">
                            <b-button @click="confirmOrder(order)" expanded rounded type="is-primary">Confirm </b-button>
                        </div>
                        <div class="column p-1">
                            <b-button disabled @click="CancelTemplate(order)" expanded rounded outlined >Cancel </b-button>
                        </div>
                    </div>
                    <div v-if="order.status == 'confirmed'" class="columns is-mobile">
                        <!-- <div class="column is-half p-1">
                            <b-button @click="confirmOrder(order)" expanded rounded type="is-primary">Track </b-button>
                        </div> -->
                        <div class="column p-1">
                            <b-button @click="viewCouriers(order)" expanded rounded outlined type="is-primary">View Couriers </b-button>
                        </div>
                    </div>
                    <div v-if="order.status == 'assigned'" class="columns is-mobile">
                        <div class="column is-half p-1">
                            <b-button tag="a" @click="deliverOrder(order)" class="is-flex is-justify-content-center is-align-items-center" rounded type="is-warning"> <span>Start delivery</span> </b-button>
                        </div>
                        <div class="column p-1">
                            <b-button tag="a" :href="`tel:${order.pickupRequest.find(cour=> cour.name == order.courier).phone.countryCode+order.pickupRequest.find(cour=> cour.name == order.courier).phone.tel}`" icon-left="phone" class="is-flex is-justify-content-center is-align-items-center" rounded type="is-primary"> <span>{{ order.courier }}</span> </b-button>
                        </div>
                    </div>
                    <div v-if="order.status == 'delivering'" class="columns is-mobile">
                        <div class="column ">
                            <b-button tag="a" :href="`tel:${order.pickupRequest.find(cour=> cour.name == order.courier).phone.countryCode+order.pickupRequest.find(cour=> cour.name == order.courier).phone.tel}`" icon-left="phone" class="is-flex is-justify-content-center is-align-items-center" expanded rounded type="is-primary"> <span>{{ order.courier }}</span> </b-button>
                        </div>
                    </div>
                    <div v-if="order.status == 'delivered'" class=" columns">
                        <div class="column ">
                            <p class="is-7 has-text-weight-semibold has-text-primary">Pay Amount - GH₵{{ formatPrice(order.payAmount) }}</p>
                        </div>
                    </div>
                </div>
            <hr class="my-2 mt-4">
            </div>
        </div>
        <!-- Modal -->
        <b-modal v-if="isCardModalActive" v-model="isCardModalActive" scroll="keep">
            <div class="p-2 card">
                <div class="p-4">
                    <h3 class="title is-5">{{ response }}</h3>
                    <p class="subtitle">Details below</p>
                </div>
               <div  v-for="courier in couriers" :key="courier._id" class="column  is-half-tablet is-half-desktop is-one-third-widescreen is-one-quarter-fullhd">
                    <div class="p-3">
                        <div class="">
                            <div v-if="courier.type">Shopnscan <b-tag type="is-primary" rounded> Support</b-tag></div>
                            <div v-else>Shopnscan <b-tag type="is-primary" rounded> Courier</b-tag></div>
                            <div class="columns is-mobile">
                                <div class="column is-four-fifths">
                                    <h4 class="title is-5 "> {{ courier.name }} </h4>
                                    <p class="subtitle is-6 "> {{ courier.phone.countryCode+courier.phone.tel }}</p>
                                </div>
                                <div class="column is-flex is-justify-content-right">
                                    <a :href="`tel:${courier.phone.countryCode+courier.phone.tel}`" class="is-primary">
                                        <feather type="phone"></feather>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="my-2 mt-4">
               </div>
                
            </div>
        </b-modal>
        <b-loading v-model="isLoading" :can-cancel="true" :is-full-page="isFullPage"></b-loading>
    </div>
</template>

<script>

    export default {
        name: 'OrderTemplate',
        data() {
            return {
                isCardModalActive: false,
                currentProduct: {},
                screenWidth: 0,
                couriers: null,
                response: "",
                isLoading:  false,
                isFullPage: true
            }
        },
        props: {
            orders: {
                required: true
            },
        },
        mounted() {
            this.updateScreenWidth();
            this.onScreenResize();
        },
        watch: {
            isCardModalActive() {
                if (this.isCardModalActive == false) {
                    this.$store.dispatch('orders/getOrders')
                }
            }
        },
        computed: {
            // ...mapGetters('cart', ['totalPrice']),
            // ...mapGetters('cart', ['cartCount']),
            // ...mapGetters('cart', ['getCartBusiness']),
            
        },
        methods: {
            formatAMPM(date) {
                date =  date ? new Date(date) : new Date()
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0'+minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                return date.toDateString()+', '+strTime;
            },
            onScreenResize() {
                window.addEventListener("resize", () => {
                    this.updateScreenWidth();
                });
            },
            updateScreenWidth() {
                this.screenWidth = window.innerWidth;
            },
            formatPrice(price) {
                return price.toFixed(2)
            },
            getDiscount(price, disc) {
                return ((100 - disc)/100) * price;
            },
            getImage(img) {
                const fullPath = '../assets/img/'+img
                console.log(fullPath)
                return fullPath
            },
            viewDetails(order){
                if (order){
                    //
                    // this.items = order.items
                    // this.isCardModalActive = true
                    this.$router.push({ name: 'orderdetails', params: { orderNo: order.orderNo }  })
                }
            },
            confirmOrder(order){
                if (order){
                    this.$buefy.dialog.confirm({
                        title: 'Confirm order',
                        message: 'Tap below to confirm.',
                        confirmText: 'Confirm',
                        onConfirm: () => {
                            // axios
                            this.$axios.post('/order/status/shop', { action: 'confirmed', orderNo: order.orderNo, shop: order.shop }).then(res => {
                                //
                                this.$buefy.toast.open(res.data.message)

                                //
                                if (res.data.data) {
                                    //
                                    this.isCardModalActive =true
                                    this.couriers = res.data.data
                                    this.response = res.data.message
                                }

                                this.$store.dispatch('orders/getOrders')

                            }).catch(error=> {
                                console.log(error)
                            })
                        }
                    })
                }
            },
            deliverOrder(order){
                
                

                if (order){

                    this.$buefy.dialog.confirm({
                        title: 'Start Order delivery',
                        message: 'Kindly <b>verify Order</b> and give to dispatch. Tap <b>Confirmed</b> below to start delivery. <b>NB:</b> Courier must be present!',
                        confirmText: 'Confirmed ',
                        onConfirm: () => {

                            this.isLoading = true
                            // axios
                            this.$axios.post('/order/status/courier', { action: 'delivering', orderNo: order.orderNo, courier: order.courier }).then(res => {
                                //
                                this.$buefy.toast.open("Great! "+res.data.message+". Thank you")

                                //
                                if (res.data.data) {
                                    //
                                    // this.isCardModalActive =true
                                    this.data = res.data.data
                                    this.response = res.data.message
                                    
                                    this.isLoading = false
                                }

                                this.$store.dispatch('orders/getOrders')

                            }).catch(error=> {
                                console.log(error)
                            })

                        }
                        
                    })

                }
            },
            CancelTemplate(order){
                if (order){
                    this.$buefy.dialog.confirm({
                        title: 'Cancel Order',
                        message: `Are you sure you want to cancel order?`,
                        confirmText: 'Yes',
                        onConfirm: () => {
                            // axios
                            this.$axios.post('/order/status/vendor', { action: 'cancelled', orderNo: order.orderNo, vendor: order.vendor }).then(res => {
                                //
                                this.$buefy.toast.open('Successful, Order is cancelled')
                                //
                                this.$store.dispatch('orders/getOrders')

                            }).catch(error=> {
                                console.log(error)
                            })
                        }
                    });
                }
            },
            viewCouriers(order) {
                this.couriers = order.pickupRequest
                this.response = "Couriers assigned to "+order.orderNo.split('-')[0]
                this.isCardModalActive = true
                this.isLoading = true

                this.$axios.get('/order/status/shop/'+order.shop+'/'+order.orderNo.split('-')[0].substring(1)).then(res => {
                                //
                                this.$buefy.toast.open(res.data.message)
                                this.isLoading = false
                                //
                                if (res.data.data) {
                                    //
                                    this.isCardModalActive =true
                                    this.couriers = res.data.data
                                    this.response = res.data.message
                                }

                                

                            }).catch(error=> {
                                console.log(error)
                            })
            }
        } 
    }
</script>

<style lang="scss" >// custom
    @import '@/assets/scss/custom_variables.scss';
    
    .modal-close {
        background: gray !important;
    }

    .order-cover {
        position: fixed;
        z-index: 50;
        width: calc(100% - 50px);
        // left: 0;
        // padding-bottom: 20px;
        margin-bottom: 5px;
        bottom: 10px;
    }
</style>